import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TolgeeService } from '@core/translation/tolgee.service';

@Pipe({
    name: 'firstErrorMessage',
    standalone: false
})
export class FirstErrorMessagePipe implements PipeTransform {

    constructor(private _tolgee: TolgeeService) {
    }

    public transform(errors: ValidationErrors, defaultMessageKey = 'common.validation.wrongChoiceInput'): string {

        if (!errors || typeof errors !== 'object') {
            return '';
        }

        const arr = Object.keys(errors)
            .filter(key => !key.startsWith('_'));

        if (arr.includes('message')) {
            return errors['message'];
        }

        const firstErrorKey = arr[0];
        const firstError = errors[firstErrorKey];

        switch (firstErrorKey) {
            case 'matDatepickerFilter':
                return this._tolgee.translate('common.validation.matDateNotAllowed');
            case 'matDatepickerParse':
                return this._tolgee.translate('common.validation.dateFormat');
            case 'matDatepickerMin':
            case 'matDatepickerMax':
                return this._tolgee.translate('common.validation.matDateOutOfRange');
            case 'matStartDateInvalid':
                return this._tolgee.translate('common.validation.matStartDateInvalid');
            case 'matEndDateInvalid':
                return this._tolgee.translate('common.validation.matEndDateInvalid');
            default:
                return firstError?.message || this._tolgee.translate(defaultMessageKey);
        }
    }
}
